const websocketAddress = (() => {
    let dynURL;
    if (typeof document != "undefined") {
        if ((dynURL = document.URL)) {

            if (dynURL.search(/localhost/) >= 0) {
                return "ws://localhost:3000";
            }

            if (dynURL.search(/wetware80/) >= 0) {
                return "wss://ed-ws.wetware80.net";
            }
        }
    }
    return "";
})();

export default websocketAddress;